// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__Jq26Z","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__y-P1w"};